var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FaCheck } from 'react-icons/fa';
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function CheckControl(_a) {
    var value = _a.value;
    return (_jsx("div", __assign({ className: 'd-flex justify-content-center' }, { children: value ? _jsx(FaCheck, { color: 'green' }, void 0) : '' }), void 0));
}
export default CheckControl;
